import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { TipoComissao } from '~/constant';
import PagamentosSinalGravarVenda from './PagamentosSinalGravarVenda';

// Wrapper que decide entre 1 stream (Padrão) ou 2 streams (Mesa + Incorporadora)
// conforme empreendimento.tipo_recebimento_comissao.
//
// Quando tipo_recebimento_comissao === RetidaCorretor:
//   - Sinal Mesa (imobiliária)  → state.vendas.sinalMesa.listaFormasDePagamentoImob
//   - Sinal Incorporadora (Setpar) → state.vendas.sinal.listaFormasDePagamento
// Caso contrário: lista única.
export default function PagamentosSinalSplit(props) {
  var empreendimento = props.empreendimento || {};
  var pagamentosIncorp = props.pagamentosIncorp || [];
  var setPagamentosIncorp = props.setPagamentosIncorp;
  var pagamentosMesa = props.pagamentosMesa || [];
  var setPagamentosMesa = props.setPagamentosMesa;
  var totalRequeridoIncorp = props.totalRequeridoIncorp || 0;
  var totalRequeridoMesa = props.totalRequeridoMesa || 0;
  var cartoes = props.cartoes || [];
  var readonly = !!props.readonly;
  var subtitulo = props.subtitulo || null;

  var requerSplit = empreendimento.tipo_recebimento_comissao === TipoComissao.RetidaCorretor;

  if (!requerSplit) {
    return (
      <PagamentosSinalGravarVenda
        parcelas={pagamentosIncorp}
        setParcelas={setPagamentosIncorp}
        totalRequerido={totalRequeridoIncorp + totalRequeridoMesa}
        cartoes={cartoes}
        titulo="Pagamento do Sinal"
        subtitulo={subtitulo}
        readonly={readonly}
      />
    );
  }

  // Split Mesa + Incorporadora: lado a lado SOMENTE em xl+. Em qualquer breakpoint
  // menor, empilha (cada card full width). Senão o conteúdo de cheque/cartão estoura
  // a largura do card e quebra a tela.
  // Split Mesa + Incorporadora: lado a lado SOMENTE em xl+. Em qualquer breakpoint
  // menor, empilha. Se algum lado tem totalRequerido=0, o card daquele lado some
  // (não há o que preencher) e o outro vira full-width.
  var temMesa = totalRequeridoMesa > 0;
  var temIncorp = totalRequeridoIncorp > 0;
  var ambos = temMesa && temIncorp;

  // Edge case: ambos 0 — empreendimento configurou RetidaCorretor mas não há valores
  // a receber. Mostra um único card vazio para não esconder a UI completamente.
  if (!temMesa && !temIncorp) {
    return (
      <PagamentosSinalGravarVenda
        parcelas={pagamentosIncorp}
        setParcelas={setPagamentosIncorp}
        totalRequerido={0}
        cartoes={cartoes}
        titulo="Pagamento do Sinal"
        subtitulo={subtitulo}
        readonly={readonly}
      />
    );
  }

  return (
    <Row className="align-items-stretch no-gutters">
      {temMesa && (
        <Col xl={ambos ? 6 : 12} xs={12} className={ambos ? 'pr-xl-1 d-flex flex-column' : 'd-flex flex-column'} style={{ minWidth: 0 }}>
          <PagamentosSinalGravarVenda
            parcelas={pagamentosMesa}
            setParcelas={setPagamentosMesa}
            totalRequerido={totalRequeridoMesa}
            cartoes={cartoes}
            titulo="Sinal Mesa (Imobiliária)"
            subtitulo="Entrada que vai para a imobiliária / Revo"
            readonly={readonly}
          />
        </Col>
      )}
      {temIncorp && (
        <Col xl={ambos ? 6 : 12} xs={12} className={ambos ? 'pl-xl-1 d-flex flex-column' : 'd-flex flex-column'} style={{ minWidth: 0 }}>
          <PagamentosSinalGravarVenda
            parcelas={pagamentosIncorp}
            setParcelas={setPagamentosIncorp}
            totalRequerido={totalRequeridoIncorp}
            cartoes={cartoes}
            titulo="Sinal Incorporadora (Setpar)"
            subtitulo="Entrada que vai para a incorporadora"
            readonly={readonly}
          />
        </Col>
      )}
    </Row>
  );
}
